webpackJsonp([104131212731371],{

/***/ 1355:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ApproveCubexMedicationInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"encounterId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"prescriberId","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-approve-cubex-medication-input-77e6f8e9b3aea9399009.js